import React from "react";
import { useNavigate } from "react-router-dom";
import { getLoggedInUser } from "../../utils/helpers";
import styled from "styled-components";
import Button from "../../components/Button";
import { colors } from "../../utils";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
  padding: 0 20px;
`;

const Title = styled.h1`
  font-size: 72px;
  margin-bottom: 16px;
  color: ${colors.PrimaryPurple500};
  font-weight: 700;
`;

const Message = styled.p`
  font-size: 20px;
  margin-bottom: 32px;
  color: #666;
  max-width: 600px;
  line-height: 1.5;
`;

const IconContainer = styled.div`
  margin-bottom: 24px;
  
  svg {
    font-size: 96px;
    color: ${colors.PrimaryPurple500};
  }
`;

const ButtonContainer = styled.div`
  width: 200px;
`;

function NotFound() {
  const navigate = useNavigate();
  const user = getLoggedInUser();

  const handleNavigateHome = () => {
    if (user) {
      navigate(`/gallery/${user.id}`);
    } else {
      navigate("/login");
    }
  };

  return (
    <Container>
      <Title>404</Title>
      <Message>
        Oops! The page you're looking for doesn't exist or has been moved.
      </Message>
      <ButtonContainer>
        <Button onClick={handleNavigateHome}>
          {user ? "Go to Gallery" : "Go to Login"}
        </Button>
      </ButtonContainer>
    </Container>
  );
}

export default NotFound; 